import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/numberForm/styles.scss';export default {
  "form": "_form_pokmc_1",
  "attribute": "_attribute_pokmc_9"
};